import { ApiKey, ApiKeyWithUnHashedKey, DeleteApiKeyDto } from 'shared/interfaces/ApiKey';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const apiKeyBaseEndpoint = '/api-key';
const zapierApiKeyBaseEndpoint = '/zapier-api-key';

export const ApiKeyService = {
  getAllApiKeys: async (isZapierKey = false): Promise<ApiKey[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${isZapierKey ? zapierApiKeyBaseEndpoint : apiKeyBaseEndpoint}/all`
    });

    return response.data;
  },
  createApiKey: async (isZapierKey = false): Promise<ApiKeyWithUnHashedKey> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${isZapierKey ? zapierApiKeyBaseEndpoint : apiKeyBaseEndpoint}`
    });

    return response.data;
  },
  deleteApiKey: async (deleteApiKeyDto: DeleteApiKeyDto): Promise<ApiKey> => {
    const response = await axiosBaseInstance({
      method: 'delete',
      url: `${deleteApiKeyDto.isZapierKey ? zapierApiKeyBaseEndpoint : apiKeyBaseEndpoint}/${deleteApiKeyDto.apiKeyId}`
    });

    return response.data;
  }
};
